import * as echarts from 'echarts'
import { addListener } from 'resize-detector'

/* eslint-disable */
export default {
  methods: {
    createChartPie(blockId, chartData) {
      var myChart = echarts.init(document.getElementById(blockId))

      let option = this.createOptionsPie(chartData)
      myChart.setOption(option)

      let zr = myChart.getZr()
      zr.on('click', e => {
        if (e.target == undefined) {
          this.destroyPopup()
        }
      })

      myChart.on('click', 'series', e => {

        let parent = null
        if (document.body.clientWidth > 768) {
          // parent = e.event.event.path[1]
          parent = document.getElementById(blockId)
        } else {
          parent = document.body
        }
        let popup = this.createPopup(e, blockId)
        parent.appendChild(popup)
        this.$emit('changeStyleButtonGoChild', {dataIndex: e.dataIndex, blockId: blockId})

        // this.$emit('go', {dataIndex: e.dataIndex, blockId: blockId})
      })

      addListener(document.getElementById(blockId), () => {
        myChart.resize()
      })
    },

    createOptionsPie(chartData) {
      let _options = {
        color: this.createColorPie(chartData),
        // title: {
        //   text: chartData.title,
        //   left: 'center'
        // },
        // tooltip: {
        //   trigger: 'item',
        //   formatter: (params) => {
        //     console.log(params)
        //   }
        // },
        legend: {
          orient: 'vertical',
          left: '10px',
          top: '15px'
        },
        series: [
          {
            name: 'series_1',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.createDataPie(chartData),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              }
            }
          }
        ]
      }
      return _options
    },

    createColorPie(chartData) {
      let _colors = []
      if (chartData.groups.length > 0 && chartData.groups[0].color !== undefined) {
        for (let i = 0; i < chartData.groups.length; i++) {
          _colors.push(chartData.groups[i].color)
        }
      } else {
        _colors = ['#f66955', '#00a65a', '#f39c11', '#00c0ef']
      }
      return _colors
    },

    createDataPie(chartData) {
      let _valueColumn = chartData.value_column
      let _groupColumn = chartData.group_column
      let _data = []

      for (let j = 0; j < chartData.groups.length; j++) {
        for (let i = 0; i < chartData.data.length; i++) {
          if (chartData.data[i][_groupColumn] === chartData.groups[j].value) { // если категория из данных совпадает с значнием из групп, что описаны в начале, то берем русский тайтл
            _data.push({
              value: chartData.data[i][_valueColumn],
              name: chartData.groups[j].title
            })
          }
        }
      }

      return _data
    }

  }
}


// WEBPACK FOOTER //
// ./src/mixins/chartPieMix.js